import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <ul>
        <Link to="/#root">
          <li>Accueil.</li>
        </Link>
        <span>|</span>
        <Link to="/#realisations">
          <li>Réalisations.</li>
        </Link>
        <span>|</span>
        <Link to="/#a-propos">
          <li>À propos.</li>
        </Link>
        <span>|</span>
        <Link to="/#contact-link">
          <li>Contact.</li>
        </Link>
        <span>|</span>
        <a
          href="https://github.com/ltrcelia?tab=repositories"
          target="_blank"
          rel="noopener noreferrer"
          className="bloc-logo"
        >
          <p className="small">GitHub.</p>
        </a>
        <span>|</span>
        <a
          href="https://www.linkedin.com/in/celia-letellier-graphiste-freelance/"
          target="_blank"
          rel="noopener noreferrer"
          className="bloc-logo"
        >
          <p className="small">Linkedin.</p>
        </a>
      </ul>
    </div>
  );
};

export default Footer;
